import { monotonicNowMs } from '../sync/server-clock.js';
/** First wait after a failure; it doubles on every failure in a row, up to the max. */
export const FAILURE_BACKOFF_INITIAL_MS = 5_000;
export const FAILURE_BACKOFF_MAX_MS = 60_000;
/**
 * Failures in a row for one thing that keeps failing (a wall tile, a playlist item, a whole
 * playlist pass). A file the TV can't decode fails in milliseconds, so without this the
 * player would retry instantly and record an event on every attempt.
 */
export class FailureStreak {
    count = 0;
    /** Records a failure. True only for the first failure of a streak: the one to report. */
    fail() {
        this.count += 1;
        return this.count === 1;
    }
    succeed() {
        this.count = 0;
    }
    get failing() {
        return this.count > 0;
    }
    /** 5 s, 10 s, 20 s, 40 s, then 60 s. 0 when not failing. */
    backoffMs() {
        if (this.count === 0)
            return 0;
        return Math.min(FAILURE_BACKOFF_MAX_MS, FAILURE_BACKOFF_INITIAL_MS * 2 ** Math.min(this.count - 1, 10));
    }
}
/**
 * Waits `ms`, checking `active` every 250 ms so a stop or a content change ends the wait
 * quickly. Tests pass `sleep` to run on fake time.
 */
export async function sleepWhile(ms, active, sleep, 
/** Monotonic, so a TV clock correction during the wait can't stretch or cut it. */
now = monotonicNowMs) {
    if (sleep) {
        if (active())
            await sleep(ms);
        return;
    }
    const end = now() + ms;
    while (active()) {
        const left = end - now();
        if (left <= 0)
            return;
        await new Promise((resolve) => setTimeout(resolve, Math.min(250, left)));
    }
}
//# sourceMappingURL=failure-backoff.js.map